import apiClient from './client'

export const paymentsApi = {
  createPayment: async (data) => {
    // If data is FormData, use it directly, otherwise convert to FormData
    let formData = data
    if (!(data instanceof FormData)) {
      formData = new FormData()
      Object.keys(data).forEach(key => {
        if (data[key] !== null && data[key] !== undefined) {
          formData.append(key, data[key])
        }
      })
    }
    
    const response = await apiClient.post('/payments', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    return response.data
  },

  getPayments: async () => {
    const response = await apiClient.get('/payments')
    return response.data
  },
}

